/**
 * Requires
 */

import $ from 'jquery'

const sdown = window.matchMedia('(max-width: 1024px)')
let windowWidth = 0

/**
 * Initialisation
 */

export function initialise() {
  // If menu clicked close it
  $('.menu-subnav').on('click', () => toggleHover())

  // Toggle bg blur class
  $('[data-toggle-target="menu"] .menu-items:not(.no-children)').on('mouseenter', () => addBlur())
  $('[data-toggle-target="menu"] .menu-items.no-children').on('mouseenter', () => removeBlur())
  $('[data-toggle-target="menu"] > ul').on('mouseleave', () => removeBlur())
  $('[data-toggle="search"]').on('click', () => toggleBlur())

  mobileClickMenu()
}

function mobileClickMenu() {
  if (sdown.matches) {
    const $toggle = $('[data-menu]')
    const $targets = $('[data-menu-target]')

    $toggle.on('click', function(event) {
      const $this = $(this)
      const id = $this.data('menu')
      const $target = $('[data-menu-target="' + id + '"]')

      if ($target.length) {
        event.preventDefault()
        $this.toggleClass('open')
        $target.toggleClass('open')
      }
    })
  }
}

function toggleHover() {
  $('.menu-items').removeClass('hover')
  setTimeout(function() {
    $(document).on('mousemove', function() {
      $('.menu-items').addClass('hover')
    })
  }, 350)
}

function toggleBlur() {
  $('#main').toggleClass('blur')
}

function addBlur() {
  $('#main').addClass('blur')
}

function removeBlur() {
  $('#main').removeClass('blur')
}
